import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** Rows or cards. Shared by every table in the app. */
export type DataTableView = "table" | "grid";

interface TableViewState {
	/**
	 * How tables are drawn, for the whole app rather than per table.
	 *
	 * One preference, not one per page: somebody who wants cards wants them in
	 * Shipments and in Cargo Lines alike, and having each table remember its own
	 * answer would mean setting the same thing a dozen times.
	 *
	 * `null` means "not chosen yet", which is different from choosing the table:
	 * until someone presses the toggle the view follows the viewport, so a phone
	 * opens on cards and a desktop on rows. The moment they press it, that
	 * answer wins everywhere and persists.
	 */
	view: DataTableView | null;
}

const initialState: TableViewState = {
	view: null,
};

const tableViewSlice = createSlice({
	name: "tableView",
	initialState,
	reducers: {
		setTableView: (state, action: PayloadAction<DataTableView>) => {
			state.view = action.payload;
		},
		/** Back to following the viewport. Nothing calls this yet. */
		clearTableView: (state) => {
			state.view = null;
		},
	},
});

export const { setTableView, clearTableView } = tableViewSlice.actions;
export default tableViewSlice.reducer;
